<template>
  <span :class="classes">
    <input v-if="isMoney"
      ref="input"
      :id="id"
      v-model.trim="val"
      :size="String(val).length || 1"
      @keyup.enter="blur()"
      @blur="onBlur()"
    >
    <input v-if="isNumber"
      ref="input"
      :id="id"
      v-model.number.trim="val"
      :size="String(val).length || 1"
      @keyup.enter="blur()"
      @blur="onBlur()"
    >
    <textarea v-if="isMultiline"
      ref="input"
      :id="id"
      v-model="val"
      :rows="val.split('\n').length || 1"
      @blur="onBlur()"
    ></textarea>
    <input v-if="!isNumber && !isMoney && !isMultiline"
      ref="input"
      :id="id"
      v-model.trim="val"
      :size="val.length || 1"
      @keyup.enter="blur()"
      @blur="onBlur()"
    >
    <label :for="id">{{ val }}</label><span v-if="isDate" ref="container"></span></span></template>

<script>
import accounting from 'accounting'
import Flatpickr from 'flatpickr'
import moment from 'moment'
// import FlatpickrPL from 'flatpickr/src/flatpickr.l10n.pl'

export default {
  props: ['value', 'id', 'class', 'number', 'block', 'money', 'multiline', 'date'],
  data () {
    return {
      val: this.isMoney ? this.toMoney(this.value) : this.value,
      datePicker: null
    }
  },
  computed: {
    isNumber () {
      return this.number === ''
    },
    isMultiline () {
      return this.multiline === ''
    },
    isMoney () {
      return this.money === ''
    },
    isBlock () {
      return this.block === ''
    },
    isDate () {
      return this.date === ''
    },
    classes () {
      const answer = {
        empty: this.val.length < 1
      }
      if (this.class) {
        answer[this.class] = true
      }
      if (this.isBlock) {
        answer.block = true
      }
      if (this.isMultiline) {
        answer.multiline = true
      }
      return answer
    }
  },
  created () {
    if (this.isMoney) {
      this.val = this.toMoney(this.val)
    }
  },
  mounted () {
    if (this.isDate) {
      // Flatpickr.localize(FlatpickrPL)
      const that = this
      this.datePicker = new Flatpickr(this.$refs.input, {
        dateFormat: 'd.m.Y',
        allowInput: true,
        defaultDate: moment(that.val, 'DD.MM.YYYY').toDate(),
        onReady: (dateObj, dateStr, instance) => {
          instance.calendarContainer.classList.remove('arrowTop')
          that.$refs.container.appendChild(instance.calendarContainer)
        },
        onChange: (dateObj, dateStr, instance) => {
          that.val = dateStr
        }
      })
    }
  },
  watch: {
    val (v) {
      if (this.isMoney) {
        const value = this.fromMoney(v)
        this.$emit('change', value)
      } else {
        this.$emit('change', v)
      }
    }
  },
  methods: {
    fromMoney (value) {
      return 100 * accounting.unformat(value, ',')
    },
    toMoney (value) {
      return accounting.formatNumber(value / 100, 2, '.', ',')
    },
    blur () {
      document.activeElement.blur()
    },
    onBlur () {
      const value = this.$refs.input.value
      if (this.isMoney) {
        this.val = this.toMoney(this.fromMoney(value))
      } else {
        this.val = value
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~assets/common.scss";
@import "~flatpickr/dist/flatpickr.min.css";

span span {
  /* podwojny span, bo przy pojedynczym psul sie hover na labelach */
  display: block;
  height: 0;
  position: relative;
}
input,textarea {
  @extend %active;
  position: fixed;
  left: -99999px;
  top: -99999px;
  width: 100%;
  height: 100%;
  border: 0;
  margin: 0;
  padding: 0;
  outline-style: none;
  font-size: inherit;
  font-family: inherit;
  text-align: inherit;
  font-weight: inherit;
  letter-spacing: inherit;

  &:focus {
    position: static;
    margin: -0.2em;
    padding: 0.2em;
    width: auto;
    max-width: 100%;

    & + label {
      display: none;
    }
  }
}
textarea {
  width: 100%;
  display: block;

  &:focus {
    width: 100%;
    display: block;
  }
  & + label {
    display: block;
  }
}
label {
  cursor: text;
  font-size: inherit;
  font-family: inherit;

  &:hover {
    @extend %canBeActive;
    margin: -0.2em;
    padding: 0.2em;
  }
}
.block {
  input:focus {
    width: 100%
  }
}
.empty {
  label {
    display: block;
    min-height: 1em;
    min-width: 1em;
  }
}
.multiline {
  label {
    white-space: pre-wrap;
  }
}
</style>
<style lang="scss">
.flatpickr-calendar.open {
  top: 0.75em !important;
  left: -100px !important;
  min-width: 256px;
  box-shadow: 0 0 1em rgba(150, 150, 150, 0.5);
}
.flatpickr-calendar:after, .flatpickr-calendar:before {
  left: 128px !important;
}
</style>



/** WEBPACK FOOTER **
 ** Editable.vue?732518bd
 **/